export const CAMPAIGN_NAMES = {
  COLLECTION_PERSONALIZED_MERCHANDISING: 'Collection Personalized Merchandising',
  COLLECTION_RECS: 'Collection Recs Above Footer',
  COLLECTION_STICKY_SUBNAV: 'Collection Sticky Subnav',
  COLLECTION_STORY_CARDS: 'Collection Story Cards',
  COLLECTION_COLORWAY_CARDS: 'Collection Colorway Cards',
  INCENTIVIZED_SIGNUP_MODAL: 'Incentivized Signup Modal',
  NOT_FOUND_RECS: 'Not found - Recs',
  PDP_ADDITIONAL_RECOMMENDATIONS: 'PDP Additional Recommendations',
  PDP_ADD_TO_CART_MODAL_RECS: 'PDP Add To Cart Modal Recommendations',
  PDP_END_OF_PAGE_CAROUSEL_RECS: 'PDP Recs End of Page',
  PDP_FLYER_ENHANCEMENTS: 'Web PDP Enhancements',
  PDP_IMAGES_EXPERIMENT: 'Product Images Experiment',
  PDP_LIFESTYLE_VIDEO: 'PDP Lifestyle Video',
  PDP_SIDEBAR_RECS: 'PDP Sidebar Recs',
  PDP_STORE_INVENTORY: 'PDP Store Inventory',
  PDP_SHOP_PAY: 'PDP Shop Pay',
  PDP_ADDITIONAL_SIZE_GUIDANCE: 'PDP Additional Size Guidance',
  PDP_BTF_STORY_MODULE: 'PDP BTF Story Module',
  PDP_STORY_MODULE_CONTENT: 'PDP Story Module Content',
  HP_DESKTOP_MINI_NAV_PLACEMENT: 'HP Desktop Mini Nav Placement',
  MULTI_TOUCH_CAMPAIGN: 'Multi-Touch Campaign',
  MULTI_TOUCH_RETURNS_MESSAGING: 'Multi-Touch Returns Messaging',
  NAVIGATION_RERUN_RENAMING: 'Navigation Rerun Renaming',
  RETURNS_INSURANCE_UPSELL: 'Returns Insurance Upsell',
};

export const CAMPAIGN_IDENTIFIERS = {
  PDP_BTF_STORY_MODULE: 'showNew',
  PDP_INTERACTIVE_MODULE: 'showInteractiveProductModule',
  PDP_PRODUCT_COMPARISON: 'showProductComparison',
  PDP_TEST_IMAGES: 'enabled',
  SHOW_PDP_SHOP_PAY: 'showPdpShopPay',
  TOP_NAVIGATION_SEARCH_ICON_MOBILE: 'showSearch',
};

export const PERSONALIZATION_STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const PDP_ADD_TO_CART_MODAL_REC_OPTIONS = {
  CONTENTFUL_UPSELLS: 'Contentful Upsells',
};

export const RERUN_LABEL = 'rerun';

export const RETURNS_MESSAGING_ATTRIBUTE = {
  _contentType: 'dropdownV2',
  internalName: 'PDP Dropdown - Shipping & Returns (Shoes)',
  header: 'Shipping & Returns',
  content: {
    data: {},
    content: [
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value:
              'Free shipping on orders over $75, and easy returns accepted within 30 days. Lightly worn shoes get donated to Soles4Souls. Visit our ',
            nodeType: 'text',
          },
          {
            data: {
              uri: 'https://www.allbirds.com/pages/returns-exchanges',
            },
            content: [
              {
                data: {},
                marks: [],
                value: 'Returns Portal',
                nodeType: 'text',
              },
            ],
            nodeType: 'hyperlink',
          },
          {
            data: {},
            marks: [],
            value: '.*',
            nodeType: 'text',
          },
        ],
        nodeType: 'paragraph',
      },
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value:
              'Final Sale items cannot be returned or exchanged. Final Sale items include: gift cards, insoles, and items tagged final sale on our website and in Allbirds retail stores.',
            nodeType: 'text',
          },
        ],
        nodeType: 'paragraph',
      },
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value: 'Need it sooner? See if the style you want is available at a ',
            nodeType: 'text',
          },
          {
            data: {
              uri: 'https://www.allbirds.com/pages/stores',
            },
            content: [
              {
                data: {},
                marks: [],
                value: 'store near you',
                nodeType: 'text',
              },
            ],
            nodeType: 'hyperlink',
          },
          {
            data: {},
            marks: [],
            value: '.',
            nodeType: 'text',
          },
        ],
        nodeType: 'paragraph',
      },
    ],
    nodeType: 'document',
  },
};
